var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    on: {
      "click": _vm.update
    }
  }, 'v-btn', Object.assign({}, _vm.$attrs, {
    loading: _vm.loading
  }), false), [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }